import React, { JSX } from "react";

export interface HookWrapperProps<T> extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
	hook: () => T;
	children: (v: T) => JSX.Element | null;
}

export function HookWrapper<T>({ hook, children }: HookWrapperProps<T>): JSX.Element | null {
	return children(hook());
}
